import router from "../router"
import Message from "@/utils/message"

export default (error, data) => {

  console.log(error) 

  let options = data || {}

  let response = {
    errorCode: 503,
    errorMessage: "Falha de comunicação com o servidor",
  }

  if (error.response && error.response.data && error.response.data.errorCode)
    response = error.response.data 

  if (options.silent)
    return response   
    
  if (isNotFoundError(error) || isUniqueViolationError(error) || isFirebaseError(error))
    return    

  console.log(response)

  if (error.response && error.response.data)
    console.log(error.response.data)

  Message.error(response.errorMessage)

  return response
}

function isNotFoundError(error) {

  let isNotFound = false

  if (error.response && error.response.status == 404) {

    isNotFound = true
    
    console.log(error.response) 
    
    router.push("/not-foud")  
  }

  return isNotFound
}

function isUniqueViolationError(error) {

  let isUniqueError = false
  let errors = null
  let data = null

  if (error.response && error.response.data) {

    data = error.response.data

    if (Array.isArray(data)) {
      errors = data
    } else if (data.errors && Array.isArray(data.errors)) {
      errors = data.errors
    }
  }

  if (errors && errors[0].type == "unique violation") {

    isUniqueError = true    
    
    console.log(error.response.data)
    
    Message.warn("Registro já existente") 
  }

  return isUniqueError
}

function isFirebaseError(error) {

  let isFbError = false
  let message = ""
  let code = error.code 

  if (!code && error.response && error.response.data)
    code = error.response.data.code

  if (!code)
    return false      

  if (code == "auth/invalid-email") {
    
    message = "E-mail inválido"

  } else if (code == "auth/user-not-found") {

    message = "Usuário não encontrado"

  } else if (code == "auth/wrong-password") {

    message = "Senha inválida"  

  } else if (code == "auth/weak-password") {

    message = "A senha deve possuir ao menos 6 caracteres"    

  } else if (code == "auth/email-already-exists") {

    message = "E-mail já cadastrado"   
  
  } else if (code == "auth/user-disabled") {

    message = "Usuário bloqueado"     
  }

  if (message) {
    
    isFbError = true

    console.log("Firebase error", { code, message })
    
    Message.info(message)
  }

  return isFbError
}